import { createBrowserRouter, RouterProvider, Route } from "react-router-dom";
import { ProvidersStackComponent } from 'components/providers/ProvidersStack';
import { UserSessionComponent } from 'components/providers/UserSession';
import { createRoot } from 'react-dom/client';
import { GAME_MODES } from "common/constants";
import React from 'react'
import "./main.scss";


const { SINGLE_PLAYER, MULTIPLAYER } = GAME_MODES;

const origin = console.error;

console.error = (error, message) => {
    if (/ChunkLoadError.+/.test(message)) {
        window.location.reload();
    } else {
        origin(error);
    }
};


createRoot(document.getElementById('root')).render(
    <UserSessionComponent>
        <RouterProvider router={createBrowserRouter([
            {
                path: "*",
                lazy: () => import(
                    /* webpackChunkName: "page-404" */
                    "controllers/404")
            },
            {
                path: "/",
                lazy: () => import(
                    /* webpackChunkName: "entry" */
                    /* webpackPrefetch: true */
                    "controllers/Entry")
            },
            {
                path: "/error",
                lazy: () => import(
                    /* webpackChunkName: "error" */
                    "controllers/GenericError")
            },
            {
                path: "/cookies",
                lazy: () => import(
                    /* webpackChunkName: "cookies" */
                    "controllers/Cookies")
            },
            {
                element: <ProvidersStackComponent />,
                children: [
                    {
                        path: "/security/code",
                        lazy: () => import(
                            /* webpackChunkName: "leap-retrieve-security-code" */
                            "controllers/LeapRetrieveSecurityCode")
                    },
                    {
                        path: "/join",
                        lazy: () => import(
                            /* webpackChunkName: "join-lobby" */
                            "controllers/JoinLobby")
                    },
                    {
                        path: "/join/:lobbyId",
                        lazy: () => import(
                            /* webpackChunkName: "join-lobby" */
                            "controllers/JoinLobby")
                    },
                    {
                        path: "/settings",
                        lazy: () => import(
                            /* webpackChunkName: "game-setting" */
                            "controllers/GameSetting")
                    },
                    {
                        path: "/after-demo",
                        lazy: () => import(
                            /* webpackChunkName: "after-demo" */
                            "controllers/AfterDemo")
                    },
                    {
                        path: '/p/:projectId',
                        lazy: () => import(
                            /* webpackChunkName: "project-drm-check" */
                            /* webpackPrefetch: true */
                            "controllers/ProjectDrmCheck"),

                        children: [
                            {
                                path: "entry",
                                lazy: () => import(
                                    /* webpackChunkName: "project-entry" */
                                    /* webpackPrefetch: true */
                                    "controllers/ProjectEntry")
                            },
                            {
                                path: `${SINGLE_PLAYER}/musics/:music/instruments`,
                                lazy: () => import(
                                    /* webpackChunkName: "instruments" */
                                    "controllers/Instruments")
                            },
                            {
                                path: `${SINGLE_PLAYER}/musics/:music/instruments/:instrument/game`,
                                lazy: () => import(
                                    /* webpackChunkName: "single-player-game" */
                                    /* webpackPrefetch: true */
                                    "controllers/SinglePlayerGame")
                            },
                            {
                                path: `${SINGLE_PLAYER}/musics/:music/instruments/:instrument/game/:gameId/result`,
                                lazy: () => import(
                                    /* webpackChunkName: "single-player-game-score" */
                                    "controllers/SinglePlayerGameScore")
                            },
                            {
                                path: `${MULTIPLAYER}/results`,
                                lazy: () => import(
                                    /* webpackChunkName: "multiplayer-results" */
                                    "controllers/MultiplayerResults")
                            },
                            {
                                path: `${MULTIPLAYER}/results/:gameId`,
                                lazy: () => import(
                                    /* webpackChunkName: "multiplayer-prev-game-result" */
                                    "controllers/MultiplayerPreviousGameResult")
                            },
                            {
                                path: `${MULTIPLAYER}/lobby/:lobbyId`,
                                lazy: () => import(
                                    /* webpackChunkName: "guest-lobby" */
                                    "controllers/GuestLobby")
                            },
                            {
                                path: `${MULTIPLAYER}/create-lobby`,
                                lazy: () => import(
                                    /* webpackChunkName: "create-lobby" */
                                    "controllers/CreateLobby")
                            },
                            {
                                path: `${MULTIPLAYER}/lobby/:lobbyId/owner`,
                                lazy: () => import(
                                    /* webpackChunkName: "owner-lobby" */
                                    "controllers/OwnerLobby")
                            },
                            {
                                path: `${MULTIPLAYER}/lobby/:lobbyId/game`,
                                lazy: () => import(
                                    /* webpackChunkName: "multiplayer-game" */
                                    /* webpackPrefetch: true */
                                    "controllers/MultiplayerGame")
                            },
                            {
                                path: `${MULTIPLAYER}/lobby/:lobbyId/result`,
                                lazy: () => import(
                                    /* webpackChunkName: "multiplayer-game-score" */
                                    "controllers/MultiplayerGameScore")
                            },
                            {
                                path: `${MULTIPLAYER}/lobby/:lobbyId/view`,
                                lazy: () => import(
                                    /* webpackChunkName: "multiplayer-game-view-only" */
                                    "controllers/MultiplayerGameViewerOnly")
                            }
                        ]
                    }
                ]
            }
        ])} />
    </UserSessionComponent>
);